import { iconClasses, ThemeOptions } from '@mui/material';

export const typography: ThemeOptions['typography'] = (palette) => {
    const gothamFontFamilies = [
        '"Gotham A"',
        '"Gotham B"',
        '"Noto Sans"',
        '"Noto Sans Thai Looped"',
        'sans-serif',
    ].join(',');
    const publicoFontFamilies = ['"Publico Headline"', '"Noto Sans"', '"Noto Sans Thai Looped"', 'serif'].join(',');

    return {
        fontSize: 16,
        fontFamily: gothamFontFamilies,
        h1: {
            fontFamily: publicoFontFamilies,
            fontWeight: 900,
            fontSize: '2.5rem',
            lineHeight: '120%',
            color: palette.text.primary,
        },
        h2: {
            fontFamily: publicoFontFamilies,
            fontWeight: 400,
            fontSize: '2rem',
            lineHeight: '120%',
            color: palette.text.primary,
        },
        h3: {
            fontFamily: publicoFontFamilies,
            fontWeight: 700,
            fontSize: '1.5rem',
            lineHeight: '120%',
            color: palette.text.secondary,
        },
        h4: {
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: '150%',
            color: palette.text.secondary,
        },
        h5: {
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: '150%',
            color: palette.text.secondary,
        },
        h6: {
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: '150%',
            color: palette.text.secondary,
        },
        body1: {
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: '150%',
            color: palette.text.secondary,
        },
        body2: {
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: '150%',
            color: palette.text.secondary,
        },
        button: {
            fontWeight: 600,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            textTransform: 'unset',
        },
        overline: {
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '0.6875rem',
            lineHeight: '150%',
            letterSpacing: '0.07em',
            color: palette.text.tertiary,
        },
        // custom
        label: {
            fontSize: '0.8125rem',
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            fontWeight: 600,
            lineHeight: '1.4rem',
        },
        helperText: {
            letterSpacing: '0em',
            fontSize: '0.75rem',
            lineHeight: '150%',
            [iconClasses.root]: {
                fontSize: '0.875rem',
            },
        },
        chip: {
            fontSize: '0.75rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            lineHeight: '1rem',
        },
        tab: {
            fontSize: '1rem',
            fontWeight: 325,
            lineHeight: '150%',
            fontStyle: 'normal',
        },
    };
};
